export enum RequestLinkType {
	Link = 1,
	Merge = 2,
}
